
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 8.5a1 1 0 000-2v2zM.293 6.793a1 1 0 000 1.414l6.364 6.364a1 1 0 001.414-1.414L2.414 7.5l5.657-5.657A1 1 0 006.657.43L.293 6.793zM1.5 6.5H1v2h.5v-2z","fill":"#1C2F45"}})])
          )
        }
      }
    